import {Leitbild} from "./leitbild";
import {GoogleMapsLibrary} from "../typescript/widgets/maps";
import {Sidenav} from "../typescript/widgets/sidenav";
import {Recommender} from "../typescript/widgets/recommender";
import {ElementorTeaserText} from "../typescript/widgets/elementorTeaserText";

import * as $ from 'jquery';
import "@fancyapps/fancybox"

import * as promisePolyfill from "es6-promise";
import { Polyfills } from './polyfills';
promisePolyfill.polyfill();

Polyfills.run();

global.M = require("@materializecss/materialize");

class Main {

	private static doc: HTMLElement;
	private static headerbarWrapper: HTMLElement;
	private static headerbarHeight: number;
	private static scroll: number;
	private static header: HTMLElement;
	private static headerbarButton: HTMLElement;

	static init() {
		document.addEventListener('DOMContentLoaded', Main.onDocumentLoaded, false);
		Main.onCareerLoad();
  	}

	private static onCareerLoad() {
		const body = document.getElementsByTagName('body')[0];
		if(body.classList.contains('page-id-4142')) {
			Main.showImgCreditsOnHover();
			Main.setWidthOfPopUp();
		}
	}

	private static setWidthOfPopUp() {
		let widthToAplicate = document.getElementsByTagName("figure")[0];
		if(widthToAplicate !== undefined) {
			let popUpWidth = widthToAplicate.offsetWidth;
			let popUp = document.getElementById("job-vacancy");
			popUp.style.width = popUpWidth + "px";
		}
	}


	private static showImgCreditsOnHover() {
		let image, figcaption, titleText, toolTip, toolTipText;
		const figures = document.getElementsByTagName('figure');

			if (figures.length > 0) {
			for(let _i = 0; _i < figures.length; _i++) {
				image = figures[_i].getElementsByTagName('img')[0];
				figcaption = figures[_i].getElementsByTagName('figcaption')[0];
				toolTip = document.createElement('div');
				toolTip.classList.add('tooltip');
				figures[_i].appendChild(toolTip);
				toolTipText = document.createElement('span');
				toolTipText.classList.add('tooltiptext');
				toolTip.appendChild(toolTipText);
				titleText = figcaption.innerText;
				toolTipText.textContent = titleText;
				figcaption.remove();
			}
		}
	}

    private static onDocumentLoaded() {
		Main.doc = document.documentElement;
		Main.header = document.getElementById('header');
		let headerbarWrapper = document.getElementById("headerbar");
		if(headerbarWrapper){
			// only if headerbar-recommendations Plugin is active
			Main.headerbarWrapper = headerbarWrapper;
			Main.headerbarButton = document.getElementById('headerbar-slide-button');
			Main.headerbarButton.addEventListener('click',Main.setHeaderTopToZero);
			Main.setHeadebarHeight();
			window.addEventListener("scroll", Main.onScroll);
		}else{
			return;
		}
		Main.setHeaderTopPosition();
	}

	private static setHeadebarHeight() {
		Main.headerbarHeight = Main.headerbarWrapper.offsetHeight;
	}

	private static onScroll() {
		Main.setHeaderTopPosition();
	}

	private static setHeaderTopPosition(){
		Main.setHeadebarHeight();
		Main.scroll = (window.pageYOffset || Main.doc.scrollTop)  - (Main.doc.clientTop || 0);
		Main.header.style.top = 'max(0px,' + String(Main.headerbarHeight - Main.scroll) + 'px)';
		if((Main.headerbarHeight - Main.scroll) < 0){
			Main.header.classList.add('sticky');
		} else {
			Main.header.classList.remove('sticky');
		}
	}

	private static setHeaderTopToZero(){
		Main.header.style.top = null;
	}

}

Main.init();
Sidenav.init();
Leitbild.init();
export { ElementorTeaserText };
export { Recommender };
export { GoogleMapsLibrary };
